function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/ico-30-back");

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/ico-30-back",
  stroke: "#440070"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.00000001,8.5 L3.00000001,12.4745223 L7.00000001,16.5 M22,21.5 L22.5,21.5 C24.9852814,21.5 27,19.4852814 27,17 C27,14.5147186 24.9852814,12.5 22.5,12.5 L21,12.5 M21.5,12.5 L3.00000001,12.5 M22,21.5 L6,21.5",
  id: "Combined-Shape"
})));

const SvgIco30Back = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30Back, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-back.2e5a4f98.svg";
export { ForwardRef as ReactComponent };